// import Vue from 'vue'
import { apolloClient } from '@/apollo'
import gql from 'graphql-tag'
import Vue from 'vue'

export const createEditTermsConditions = gql`
mutation createEditTermsConditions($terms: [pay4supply_terms_and_conditions_insert_input!]!, $update_columns: [pay4supply_terms_and_conditions_update_column!] = [id, active, published, terms, updated_at, version]) {
  insert_terms_pay4supply: insert_pay4supply_terms_and_conditions(objects: $terms, on_conflict: {constraint: terms_and_conditions_pkey1, update_columns: $update_columns}) {
    returning {
      id
    }
  }
}
`

export const createEditSetOtherRecordsActiveFalseTyC = gql`
mutation createEditSetOtherRecordsActiveFalseTyC($terms: [pay4supply_terms_and_conditions_insert_input!]!, $update_columns: [pay4supply_terms_and_conditions_update_column!] = [id, active, published, terms, updated_at, version], $version: String!) {
  insert_pay4supply_terms_and_conditions(objects: $terms, on_conflict: {constraint: terms_and_conditions_pkey1, update_columns: $update_columns}) {
    returning {
      id
    }
  }
  update_pay4supply_terms_and_conditions(where: {version: {_neq: $version}, active: {_eq: true}}, _set: {active: false}) {
    returning {
      id
    }
  }
}
`

export const getAllTermsConditions = gql`
query getAllTermsConditions {
  pay4supply_terms_and_conditions(order_by: {version: desc}, distinct_on: version) {
    published
    updated_at
    id
    active
    created_at
    version
  }
}
`
export const GET_TERMS_BY_VERSION = gql`
query GET_TERMS_BY_VERSION($version: String!) {
  pay4supply_terms_and_conditions(where: {version: {_eq: $version}}) {
    active
    published
    id
    lang
    version
    terms
  }
}
`

export const updateTermsConditions = gql`
  mutation updateTermsConditions($id: Int = 10, $active: Boolean = false, $updated_at: timestamptz = "", $terms: String = "", $published: Boolean = false) {
    update_pay4supply_terms: update_pay4supply_terms_and_conditions_by_pk(pk_columns: {id: $id}, _set: {active: $active, updated_at: $updated_at, terms: $terms, published: $published}) {
      id
    }
  }
`

export const GET_ORG_ACCEPTED_TERMS = gql`
  query GET_ORG_ACCEPTED_TERMS {
    pay4supply_organization_accepted_terms(order_by: {id: desc}) {
      form_data
      id
      rut
    }
  }
`

const pay4supply = {
  namespaced: true,
  state: {
    terminosCondiciones: [],
    orgAcceptedTerms: []
  },
  actions: {
    async createTermsConditions ({ dispatch }, variables) {
      try {
        const response = await apolloClient.mutate({
          mutation: (variables.version == null) ? createEditTermsConditions : createEditSetOtherRecordsActiveFalseTyC,
          variables
        })
        if (response && response.data) {
          dispatch('fetchAll')
          return response.data
        }
        throw new Error('Error al crear terminos y condiciones')
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async fetchAll ({ state }) {
      try {
        const response = await apolloClient.query({
          fetchPolicy: 'network-only',
          query: getAllTermsConditions
        })
        if (response && response.data && response.data.pay4supply_terms_and_conditions) {
          Vue.set(state, 'terminosCondiciones', response.data.pay4supply_terms_and_conditions)
          return response.data.pay4supply_terms_and_conditions
        }
      } catch (error) {
        console.error(error)
        return error
      }
    },
    async getTermsByVersion (store, variables) {
      try {
        const response = await apolloClient.query({
          query: GET_TERMS_BY_VERSION,
          variables
        })
        if (response && response.data && response.data.pay4supply_terms_and_conditions) return response.data.pay4supply_terms_and_conditions
        return null
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async editTermsConditions ({ dispatch }, variables) {
      try {
        const response = await apolloClient.mutate({
          mutation: updateTermsConditions,
          variables
        })
        if (response && response.data && response.data.update_pay4supply_terms) {
          dispatch('fetchAll')
          return response.data.update_pay4supply_terms
        }
      } catch (error) {
        console.error(error)
        return error
      }
    },
    async getOrgAccTerms ({ state }) {
      try {
        const response = await apolloClient.query({
          fetchPolicy: 'network-only',
          query: GET_ORG_ACCEPTED_TERMS
        })
        if (response && response.data) state.orgAcceptedTerms = response.data.pay4supply_organization_accepted_terms
        return response.data.pay4supply_organization_accepted_terms
      } catch (error) {
        console.error(error)
        return error
      }
    }
  },
  mutations: {
  }
}

export default pay4supply



// WEBPACK FOOTER //
// ./src/store/modules/pay4supply.js